const data = {
    meta : {
        title       : "Blog - Developer Software, Website dan Aplikasi Mobile Terbaik di Makassar",
        description : "Mari lebih dekat dengan informasi teknologi terbaru dan seputar kegiatan kami.",
        imageUrl    : "/images/banner/banner-2.png",
        imageAlt    : "/images/banner/banner-2.png"
    },
    banner : {
        id : {
            title : "BLOG",
            subTitle : "Mari lebih dekat dengan informasi teknologi terbaru dan seputar kegiatan kami."
        }
    }
}

export default data